import { render } from "./ModalForm.vue?vue&type=template&id=7eddfe83"
import script from "./ModalForm.vue?vue&type=script&lang=js"
export * from "./ModalForm.vue?vue&type=script&lang=js"
script.render = render

export default script